<template>
  <div class="tile is-parent is-vertical">
    <a v-bind:href="`/videos/view/${this.video.alias}`">
      <div class="video-card video-card--vertical card p-4">
        <div style="position: relative">
          <img v-bind:src="this.video.picture_no_text" v-bind:alt="this.video.title"
               class="video-cover card-image"/>
          <h5 class="video-card__header">{{ this.video.title }}</h5>
          <div class="is-flex is-justify-content-space-between video-card__bottom px-1">
            <span v-if="this.video?.duration">
              <i class="fa-solid fa-hourglass"></i>
              ~{{ this.video.duration }} мин
            </span>
            <span v-if="this.video?.teachers?.length > 0">{{ this.video.teachers[0]?.name }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'VideoCard',
  props: ['video'],
  methods: {},
}
</script>

<style>
.video-card {
  transition-duration: 200ms;
}

.video-card:hover {
  box-shadow: 0 0em 1em 0em rgb(38 118 136 / 30%);
}

.video-cover {
  min-height: 213px;
}

.video-card--vertical {
  min-width: auto;
  max-width: none;
}

.video-card--vertical .video-cover {
  min-height: 150px;
}

.video-card__header {
  position: absolute;
  top: 20px;
  text-shadow:
      0 0 2px #fff,
      0 0 5px #fff,
      0 0 10px #fff;
}
.video-card__bottom {
  position: absolute;
  width: 100%;
  bottom: -1px;
  font-weight: 700;
  text-shadow:
      0 0 2px #fff,
      0 0 5px #fff,
      0 0 10px #fff;
}
@media screen and (min-width: 768px) and (max-width: 1300px) {
  .video-card__header, .video-card__bottom {
    font-size: smaller;
  }
}
</style>
